import React, { useState, useEffect } from "react";
import "./productDetails.scss";
import {
  Box,
  Chip,
  Divider,
  Grid,
  MenuItem,
  Select,
  useMediaQuery,
  Skeleton,
} from "@mui/material";
import { PRODUCT_IMAGE_URL } from "../../../constant";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import cartStore from "../../../store/cartStore";
import authStore from "../../../store/authStore";
import wishlistStore from "../../../store/wishlistStore";
import ReactPixel from "react-facebook-pixel";

// swiper
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-creative";
import "swiper/css/pagination";
// import required modules
import { EffectCreative } from "swiper/modules";
// import required modules
import { Pagination } from "swiper/modules";
// swiper

// icon
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";

const ProductDetails = ({ data, totalReview, averageRating }) => {
  const matches = useMediaQuery("(max-width:600px)");
  const CartStore = cartStore();
  const AuthStore = authStore();
  const WishlistStore = wishlistStore();

  const [sizeSelect, setSizeSelect] = useState(null);
  const [isSizeSelect, setIsSizeSelect] = useState(false);
  const [colorSelect, setColorSelect] = useState(null);
  const [isColorSelect, setIsColorSelect] = useState(false);
  const navigate = useNavigate();
  const [howManyColor, setHowManyColor] = useState([]);
  const [isAddToCart, setIsAddToCart] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isWishlist, setIsWishlist] = useState(false);
  const [isWishlistLoading, setIsWishlistLoading] = useState(false);
  const [wishlistID, setWishlistID] = useState();

  useEffect(() => {
    const how = [];
    const color = [];
    for (let i = 1; i <= data.howManyColor; i++) {
      how.push(i);
      color.push("select-color");
    }
    setColorSelect([...color]);
    setHowManyColor(how);
  }, [data]);

  useEffect(() => {
    if (WishlistStore.wishlistProduct) {
      for (let i = 0; i < WishlistStore.wishlistProduct.length; i++) {
        if (data._id === WishlistStore.wishlistProduct[i].productID) {
          setIsWishlist(true);
          setWishlistID(WishlistStore.wishlistProduct[i]._id);
          break;
        }
      }
    }
  }, [WishlistStore.wishlistProduct && WishlistStore.wishlistProduct.length]);

  useEffect(() => {
    if (CartStore.cartProduct) {
      setIsAddToCart(false);
      setSizeSelect(null);
      CartStore.cartProduct.map((item) => {
        if (item.productID === data._id) {
          setIsAddToCart(true);
          setColorSelect(item.selectedColor);
          setSizeSelect(item.selectedSize);
        }
      });
    }
  }, [CartStore.cartProduct && CartStore.cartProduct.length, data]);

  const AddToCart = async () => {
    if (data.productSizes.length > 0) {
      if (!sizeSelect) {
        setIsSizeSelect(true);
      }
    }
    let flag = 0;
    // console.log(data.howManyColor);
    for (let i = 1; i <= data.howManyColor; i++) {
      if (colorSelect[i - 1] === "select-color") {
        setIsColorSelect(true);
        flag++;
        break;
      }
    }

    if ((data.productSizes.length > 0 && !sizeSelect) || flag !== 0) {
      return false;
    }

    if (AuthStore.isLogged) {
      setIsLoading(true);
      await CartStore.signInAdd({
        productID: data._id,
        selectedColor: colorSelect,
        selectedSize: sizeSelect,
      });
      setIsLoading(false);
    } else {
      await CartStore.noSignInAdd({
        productID: data._id,
        selectedColor: colorSelect,
        selectedSize: sizeSelect,
      });
    }

    ReactPixel.track("AddToCart", {
      content_ids: [data._id],
      content_name: data.productName,
      value: data.salePrice ? data.salePrice : data.regularPrice,
      currency: "INR",
    });
  };

  useEffect(() => {
    if (isColorSelect) {
      let flag = 0;
      for (let i = 1; i <= data.howManyColor; i++) {
        if (colorSelect[i - 1] === "select-color") {
          flag++;
          break;
        }
      }
      if (flag !== 0) {
        setIsColorSelect(true);
      } else {
        setIsColorSelect(false);
      }
    }
  }, [colorSelect]);

  return (
    <div className="product-details">
      <Grid container spacing={matches ? 0 : 4}>
        <Grid
          container
          item
          className="left-side"
          spacing={2}
          lg={7}
          md={8}
          sm={6}
          xs={12}
        >
          <div
            style={{
              marginLeft: "5px",
              transition: "all 0.5s ease",
              width: "100%",
            }}
          >
            <Grid container spacing={2}>
              {data &&
                data.productImages.map((image, index) => {
                  if (index === 4) {
                    return (
                      <Grid
                        item
                        xs={12}
                        key={index}
                        className="is-web-image"
                        display={{
                          xs: "none",
                          lg: "block",
                          sm: "none",
                          md: "block",
                        }}
                      >
                        <div className="product-single-image contain">
                          <img
                            src={`${PRODUCT_IMAGE_URL}${image}`}
                            alt={`${PRODUCT_IMAGE_URL}${image}`}
                          />
                        </div>
                      </Grid>
                    );
                  } else {
                    return (
                      <Grid
                        item
                        xs={6}
                        key={index}
                        className="is-web-image"
                        display={{
                          xs: "none",
                          lg: "block",
                          sm: "none",
                          md: "block",
                        }}
                      >
                        <div className="product-single-image">
                          <img
                            src={`${PRODUCT_IMAGE_URL}${image}`}
                            alt={image}
                          />
                        </div>
                      </Grid>
                    );
                  }
                })}
            </Grid>

            <Grid
              item
              xs={12}
              className="is-mobile-image"
              sx={{ mt: 5 }}
              display={{ xs: "block", lg: "none", sm: "block", md: "none" }}
            >
              <Box>
                <Swiper
                  grabCursor={true}
                  effect={"creative"}
                  creativeEffect={{
                    prev: {
                      shadow: true,
                      translate: [0, 0, -400],
                    },
                    next: {
                      translate: ["100%", 0, 0],
                    },
                  }}
                  pagination={{
                    dynamicBullets: true,
                  }}
                  modules={[EffectCreative, Pagination]}
                  className="carousel"
                >
                  {data &&
                    data.productImages.map((image, index) => (
                      <SwiperSlide key={index}>
                        <div
                          className={`singleCarousel ${
                            index === 4 && "contain"
                          }`}
                          key={index}
                        >
                          <img
                            src={`${PRODUCT_IMAGE_URL}${image}`}
                            alt={image + " - " + index}
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </Box>
            </Grid>
          </div>
        </Grid>
        <Grid
          container
          item
          spacing={2}
          lg={5}
          md={4}
          sm={6}
          xs={12}
          className="right-side-details"
        >
          <Grid container item>
            <Box
              component="div"
              sx={{ width: "100%", transition: "all 0.5s ease" }}
            >
              <h1 className="product-name">{data.productName}</h1>
              <p className="product-sub-description">
                {data.productSubDescription}
              </p>
              <div className="rating">
                <p className="rating-star">
                  {parseFloat(averageRating).toFixed(1)}
                </p>
                <StarRoundedIcon className="icon" />
                <p className="total-rating">
                  (
                  {totalReview > 999
                    ? (totalReview / 1000).toFixed(2) + "k"
                    : totalReview}{" "}
                  Reviews)
                </p>
              </div>
              <div className="price">
                {data.salePrice && (
                  <div className="sale-price">₹{data.salePrice}</div>
                )}
                <div className={`regular-price ${data.salePrice && "is-sale"}`}>
                  ₹{data.regularPrice}
                </div>
              </div>
              {data.productSizes.length !== 0 && (
                <div className="sizes">
                  <p>Select Size</p>
                  <p
                    style={{
                      fontSize: isSizeSelect ? "15px" : 0,
                      fontWeight: 500,
                      color: "#D01110",
                      textTransform: "inherit",
                    }}
                  >
                    Please select a size *
                  </p>
                  <div className="size-chip">
                    {data.productSizes.map((size) => (
                      <Chip
                        key={size}
                        label={size}
                        disabled={isAddToCart}
                        variant={sizeSelect === size ? "filled" : "outlined"}
                        className="chip"
                        onClick={() => {
                          setSizeSelect(size);
                          setIsSizeSelect(false);
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}

              {data.productColors.length !== 0 && (
                <div className="colors">
                  <p>Select Color</p>
                  <p
                    style={{
                      fontSize: isColorSelect ? "15px" : 0,
                      fontWeight: 500,
                      color: "#D01110",
                      textTransform: "inherit",
                    }}
                  >
                    Please select a color *
                  </p>
                  <div className="color-select-container">
                    {howManyColor &&
                      howManyColor.map((i) => (
                        <Select
                          key={i}
                          disabled={isAddToCart}
                          value={colorSelect ? colorSelect[i - 1] : []}
                          onChange={(e) => {
                            const dataTemp = [...colorSelect];
                            dataTemp[i - 1] = e.target.value;
                            setColorSelect(dataTemp);
                          }}
                          className="color-select"
                        >
                          <MenuItem value="select-color" disabled>
                            Select Color
                          </MenuItem>
                          {data.productColors.map((color) => (
                            <MenuItem value={color} key={color}>
                              {color}
                            </MenuItem>
                          ))}
                        </Select>
                      ))}
                  </div>
                </div>
              )}

              {AuthStore.myUser && (
                <LoadingButton
                  className="wishlist-btn"
                  loading={isWishlistLoading}
                  sx={{ color: !isWishlistLoading && "#000" }}
                  startIcon={
                    isWishlist ? (
                      <FavoriteRoundedIcon className="icon" />
                    ) : (
                      <FavoriteBorderRoundedIcon className="icon" />
                    )
                  }
                  onClick={async () => {
                    setIsWishlistLoading(true);
                    if (isWishlist) {
                      await WishlistStore.removeToWishlist({
                        wishlistID,
                        productID: data._id,
                        productName: data.productName,
                        productPrice: data.salePrice
                          ? data.salePrice
                          : data.regularPrice,
                      });
                    } else {
                      await WishlistStore.addToWishlist({
                        productID: data._id,
                        productName: data.productName,
                        productPrice: data.salePrice
                          ? data.salePrice
                          : data.regularPrice,
                      });
                    }
                    setIsWishlistLoading(false);
                    setIsWishlist(!isWishlist);
                  }}
                >
                  <p>Quick Look</p>
                </LoadingButton>
              )}

              <div className="delivery-days">
                Delivery within <span>{data.deliverDays} days</span>
              </div>
              <div className="cart-btn">
                <LoadingButton
                  loading={isLoading}
                  variant="contained"
                  style={{
                    background:
                      isLoading ||
                      !data.publish ||
                      !data.currentStock ||
                      data.currentStock === 0
                        ? "#f5f5f5"
                        : "",
                    color:
                      (!data.publish ||
                        !data.currentStock ||
                        data.currentStock === 0) &&
                      "#000",
                  }}
                  className="btn"
                  disabled={
                    data.publish && data.currentStock >= 1 ? false : true
                  }
                  onClick={
                    isAddToCart
                      ? () => {
                          navigate("/checkout");
                        }
                      : AddToCart
                  }
                >
                  <p>
                    {!data.publish ||
                    !data.currentStock ||
                    data.currentStock === 0
                      ? "Out Of Stock"
                      : isAddToCart
                        ? "Go To Cart"
                        : "Add To Cart"}
                  </p>
                </LoadingButton>
              </div>

              <Divider className="divider" />
              <div className="product-description">
                <p className="desc-title">Description</p>
                <div
                  className="html-desc"
                  dangerouslySetInnerHTML={{
                    __html: data.productContent,
                  }}
                />
              </div>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ProductDetails;
